import { Suspense, useEffect } from "react";
// import './App.css';
import withSession from "./features/session/Session";

import { selectUserRole, type User } from "@/features/session/sessionSlice";
import MicrofrontendAuthProvider from "./components/MicrofrontendAuthProvider";
import { useAppSelector } from "./app/hooks";
import { APP_ROLE, APP_ROLE_VALUES } from "./features/session/utils/enums";
import { Navigate, Route, Routes } from "react-router-dom";
import routes from "./app/routes";
import { Spinner } from "@yaradigitallabs/ahua-react";
import LoginPage from "./pages/login";
import AuthRoute from "./components/AuthRoute";
import Layout from "./pages";
import config from "./config";
import Header from "./components/ui/Header";

const App = ({
  signIn,
  signOut,
  user,
}: {
  signIn: () => void;
  signOut: () => void;
  user: User | null;
}) => {
  const role: string = useAppSelector(selectUserRole);
  const isAuthenticated = !!user;

  return (
    <div>
      <MicrofrontendAuthProvider>
        {user && <Header title={config.appName} signOut={signOut} />}
        <Suspense fallback={<Spinner />}>
          <Routes>
            <Route
              path={routes.LOGIN}
              element={
                !isAuthenticated ? (
                  <LoginPage signIn={signIn} />
                ) : (
                  <Navigate to={routes.HOME} />
                )
              }
            />
            <Route
              path={routes.LAYOUT}
              element={
                <AuthRoute isAuthenticated={isAuthenticated}>
                  <Layout isAuthenticated={isAuthenticated} />
                </AuthRoute>
              }
            />
          </Routes>
        </Suspense>
      </MicrofrontendAuthProvider>
    </div>
  );
};

export default withSession(App);
